import PropTypes from 'prop-types';
import * as Styled from './PricingComponent.styles';
import { Header } from './components/Header/Header';
import {SubHeader} from './components/SubHeader/SubHeader';
import { Price } from './components/Price/Price';
import { PlanType } from './components/PlanType/PlanType';
import { Stack } from '@mui/material';
import { ClientChoice } from './components/ClientChoice/ClientChoice';
export const PricingComponent = ({current,planName, type, description, price, subPrice, productId, productCode}) => {
  return (
    <Styled.Stack type={type?.toLowerCase()}>
      <Stack>
        <Header>{planName}</Header>
        <SubHeader>{description}</SubHeader>          
        {type ==='standard' && <ClientChoice/>}     
        {type !=='standard' && <Styled.EmptyContainer/>}      
      </Stack>     
      <Styled.BottomContainer>    
        <Price price={price} subPrice={subPrice}/>
        <PlanType productId={productId} productCode={productCode} current={current}/>
          {type ==='free' && 
            <Styled.Description>Za darmo na zawsze</Styled.Description>
          }
          {type !='free' && 
            <Styled.Description>30 dni bezpłatnie</Styled.Description>
          }           
      </Styled.BottomContainer>       
    </Styled.Stack>
  );
};

PricingComponent.propTypes = {
  planName: PropTypes.string  
};
